import React from 'react'
import type { PlatformPlayerProps } from './playerTypes'

/* The player (Vidstack + its CSS) is its own chunk, fetched when the first video renders. */
const PlatformPlayerChunk = React.lazy(() => import('./PlatformPlayer'))

/** The platform player, loaded on demand; a black frame holds its place meanwhile. */
export const LazyPlatformPlayer = (props: PlatformPlayerProps) => (
  <React.Suspense fallback={<div className="h-full min-h-[120px] w-full bg-black" aria-hidden />}>
    <PlatformPlayerChunk {...props} />
  </React.Suspense>
)
